var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContractorIcon = function SvgContractorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#237C82",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.75 20.75v-3c0-1.886 0-2.828-.586-3.414s-1.528-.586-3.414-.586h-2l-2 2-2-2h-2c-1.886 0-2.828 0-3.414.586S.75 15.864.75 17.75v3M12.75 13.75v7M4.75 13.75v7M12.25 7.75v-2a3.5 3.5 0 1 0-7 0v2a3.5 3.5 0 1 0 7 0M4.25 6.25h9M8.75.75v1.5"
  })));
};
export default SvgContractorIcon;